import tagmanager from '../abstracts/tagmanager';

const track = () => {
  const identifier = {
    class: '.js-track',
  };

  const init = () => {
    document.addEventListener('DOMContentLoaded', () => {
      initTracking();
    });
  };

  const initTracking = () => {
    const elements = document.querySelectorAll(identifier.class);

    elements.forEach((element) => {
      element.addEventListener('click', (e) => {
        sendTracking(e.currentTarget);
      });
    });
  };

  init();
};

export default track;

// compatibility (can be removed at a later date)
const sendTracking = (element) => sendTrackingClick(element);

const sendTrackingClick = (element) => {
  const trackingEvent = element.getAttribute('data-tracking-event');
  const trackingCategory = element.getAttribute('data-tracking-category');
  const trackingData = element.getAttribute('data-tracking-data') || '{}';

  if (!trackingEvent) {
    return;
  }

  if (trackingCategory && trackingCategory.length) {
    tagmanager.event(trackingEvent, {
      Selection: trackingCategory,
      ...JSON.parse(trackingData),
    });
  } else {
    // send just event without any Selection
    tagmanager.event(trackingEvent, JSON.parse(trackingData));
  }
};

const sendTrackingImpression = (element) => {
  const trackingEvent = element.getAttribute('data-tracking-event-view');
  const trackingCategory = element.getAttribute('data-tracking-category');
  const trackingData = element.getAttribute('data-tracking-data') || '{}';

  if (!trackingEvent) {
    return;
  }

  if (trackingCategory && trackingCategory.length) {
    tagmanager.event(trackingEvent, {
      Selection: trackingCategory,
      ...JSON.parse(trackingData),
    });
  } else {
    // send just event without any Selection
    tagmanager.event(trackingEvent, JSON.parse(trackingData));
  }
};

export { sendTracking, sendTrackingClick, sendTrackingImpression };
